import React, { Dispatch, SetStateAction } from "react";
import "./Answers.scss";
import { DNAAnswers, DNAElementValue } from "../DNA/DNA";
import { ElementAnswers } from "./ElementAnswers/ElementAnswers";
import { clone } from "lodash";

interface IProps {
    answers: DNAAnswers
    setAnswers?: Dispatch<SetStateAction<DNAAnswers>>
}

export function Answers({
    answers,
    setAnswers
                        }: IProps) {
    const setElementAnswers = (index: number) => {
        if (!setAnswers) return undefined;
        return (value: DNAElementValue[]) => {
            setAnswers((prevState) => {
                const newState = clone(prevState);
                newState[index] = value;
                return newState;
            });
        }
    }

    return (
        <div className="answers-wrapper">
            {answers.map((elementAnswer, index) => {
                return <ElementAnswers answers={elementAnswer} key={index} setAnswers={setElementAnswers(index)} />
            })}
        </div>
    )
}
